import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';
import { isWidthUp, isWidthDown } from '@material-ui/core/withWidth';
import Grid from '@material-ui/core/Grid';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';

import { DIMENSIONS } from '../../styles/constants';
import { buildVinNomNote } from './utils';
import { useStyles } from './styles';
import Paper from '../Paper';
import LineAmChart from './LineAmChart';
import ChartsSelect from './ChartsSelect';

const Charts = ({ page, withTitle, screenWidth }) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const [isLoading, setIsLoading] = useState(true);
	const charts = useSelector(state => state.selectedDesign.detail.charts);
	const myDesignId = useSelector(state => state.selectedDesign.myDesign.id);
	const inputParametersSD = useSelector(state => state.selectedDesign.detail.inputParameters);
	const initialVinNom = useSelector(state => state.selectedDesign.initialInputParameters.vinNom);
	const progressActive = useSelector(state => state.tabbar.progressActive);

	/* To display initial skeleton loading */
	useEffect(() => {
		const timer = setTimeout(() => {
			setIsLoading(false);
		}, 100);

		return () => {
			clearTimeout(timer);
		};
	}, [charts]);

	/* UseEffect(() => {
        if (!isLoading) {
            const allCharts = charts.map(chart => chart.chartName);

            allCharts.forEach(chart => {
                document.getElementById(
                    chart + '-chart-tile'
                ).style.display = selectedCharts.includes(chart)
                        ? 'list-item'
                        : 'none';
            });
        }
    }, [charts, isLoading, selectedCharts]); */

	return (
		<Paper padding={[1, 2, 2, 2]}>
			<Grid container direction="column">
				<Grid
					item
					container
					direction="row"
					alignItems="center"
					justify={withTitle ? 'space-between' : 'flex-end'}
					className={classes.header}>
					{withTitle &&
						(progressActive ? (
							<Skeleton width={DIMENSIONS.SKELETON_BUTTON_WIDTH} height={DIMENSIONS.SKELETON_TITLE_HEIGHT} />
						) : (
							<Grid item>
								<Typography variant="h6">{t('components.summary.charts')}</Typography>
							</Grid>
						))}

					<Grid item>
						{progressActive ? (
							<Skeleton
								variant="circle"
								width={DIMENSIONS.SKELETON_BUTTON_HEIGHT}
								height={DIMENSIONS.SKELETON_BUTTON_HEIGHT}
							/>
						) : (
							<ChartsSelect page={page} />
						)}
					</Grid>
				</Grid>

				<Grid item container direction="column" justify="space-between">
					<Grid item xs>
						<GridList
							id="Charts__grid_list"
							cellHeight={'auto'}
							cols={isWidthUp('lg', screenWidth) ? 2 : 1}
							spacing={isWidthDown('xs', screenWidth) ? 0 : 35}
							className={classes.chartGrid}>
							{charts.map((chart, index) => (
								<GridListTile
									key={chart.chartName + index}
									id={chart.chartName + '-chart-tile'}
									className={classes.gridListTile}>
									{isLoading ? (
										<Skeleton variant="rect" width="100%" height={320} />
									) : (
										<LineAmChart
											designId={myDesignId}
											chartId={chart.chartName}
											data={chart}
											inputParams={inputParametersSD}
										/>
									)}
								</GridListTile>
							))}
						</GridList>
					</Grid>

					{initialVinNom === '' &&
						(progressActive ? (
							<Skeleton height={DIMENSIONS.SKELETON_TEXT_HEIGHT} />
						) : (
							<Grid item xs className={classes.noteContainer}>
								<Typography variant="caption" color="textSecondary">
									{buildVinNomNote(inputParametersSD)}
								</Typography>
							</Grid>
						))}
				</Grid>
			</Grid>
		</Paper>
	);
};

Charts.propTypes = {
	page: PropTypes.string.isRequired,
	withTitle: PropTypes.bool,
	screenWidth: PropTypes.string.isRequired
};

export default Charts;
